var render = function render(){var _vm=this,_c=_vm._self._c;return _c(_vm.themeName,{tag:"component",attrs:{"id":_vm.themeName}})
}
var staticRenderFns = []

export { render, staticRenderFns }